import { AppearanceState } from "./state";
import StoreModule from "../core/StoreModule";

class AppearanceStore extends StoreModule<AppearanceState> {
  PDFVIEWERTOOLBAR_HEIGHT = 400;
  PDFVIEWERTOOLBAR_NO_LAYOUT_TOOLBAR_HEIGHT = 60;
  PDFVIEWERCONTAINER_PADDING_SM = 10;
  PDFVIEWERCONTAINER_PADDING_LG = 40;
  PDFVIEWERPAGE_PADDING_SM = 10;
  PDFVIEWERPAGE_PADDING_LG = 40;
  PDFVIEWER_BREAKPOINT = 860;
  PDFVIEWER_HEADER = 72;

  protected state: AppearanceState = {
    overlay: false,
    currentHeight: 0,
    currentWidth: 0,
    hideInsertDetails: false,
    hideLayoutToolbar: false,
  };

  get overlay() {
    return this.state.overlay;
  }

  set overlay(val: AppearanceState["overlay"]) {
    this.setState({ overlay: val });
  }

  get hideInsertDetails() {
    return this.state.hideInsertDetails;
  }

  set hideInsertDetails(val) {
    this.setState({ hideInsertDetails: val });
  }

  get hideLayoutToolbar() {
    return this.state.hideLayoutToolbar;
  }

  set hideLayoutToolbar(val) {
    this.setState({ hideLayoutToolbar: val });
  }

  get currentHeight() {
    return this.state.currentHeight;
  }

  set currentHeight(val) {
    this.setState({ currentHeight: val });
  }

  get currentWidth() {
    return this.state.currentWidth;
  }

  set currentWidth(val) {
    this.setState({ currentWidth: val });
  }

  get appHeight() {
    return (this.currentHeight - this.PDFVIEWER_HEADER).toString() + "px";
  }
  get pdfViewerHeight() {
    return (
      (
        this.currentHeight -
        (this.hideLayoutToolbar
          ? this.PDFVIEWERTOOLBAR_NO_LAYOUT_TOOLBAR_HEIGHT
          : this.PDFVIEWERTOOLBAR_HEIGHT) -
        this.PDFVIEWER_HEADER
      ).toString() + "px"
    );
  }

  get pdfViewerToolbarHeight() {
    return `${
      this.hideLayoutToolbar
        ? this.PDFVIEWERTOOLBAR_NO_LAYOUT_TOOLBAR_HEIGHT
        : this.PDFVIEWERTOOLBAR_HEIGHT
    }px`;
  }

  get pdfViewerContainerPadding() {
    return (
      (this.currentWidth < this.PDFVIEWER_BREAKPOINT
        ? this.PDFVIEWERCONTAINER_PADDING_SM
        : this.PDFVIEWERCONTAINER_PADDING_LG
      ).toString() + "px"
    );
  }

  get pdfViewerPageWidth() {
    return (
      this.currentWidth -
      (this.currentWidth < this.PDFVIEWER_BREAKPOINT
        ? this.PDFVIEWERPAGE_PADDING_SM
        : this.PDFVIEWERPAGE_PADDING_LG) *
        2
    );
  }
}

export const $appearance = StoreModule.singleton(AppearanceStore);
